import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App';

function Main() {
  return (
    <div>
        <App></App>
    </div>
  )
}

const root = createRoot(document.getElementById('root'));
root.render(<Main></Main>)